export class ChildReferralRequest {
    //child info
    //Code is auto-generated in API
    DOB: string;
    AgeMonth: number;
    VAUserId: string; // userid
    RegionId: number;
    City: string;
    ZipCode: string;
    HomeLanguage: string;    
    //child classroom info
    ClassroomId: number;
    ProgramId: number;
    //child details
    NeedsInterpreter: boolean;
    NeedsFosterCare: boolean;
    Race: string;
    IsHispanic?: boolean;
    Gender: string;
    IsIFSP: boolean;
    IFSPSvc: string;
    Diagnosis: string;
    Medications: string;
    Allergies: string;
    Referral: string;
    OtherAgencies: string;// mismatch should be other agencies involved
    HasExpulsionRisk?: boolean;
    ReceivesSubsidy?: boolean;
    StartedAttending: string;
    ClassStudentCount: number;
    //Reasons for referral
    HasAdaptiveBehavior?: boolean;
    HasAffect?: boolean;
    HasAggression?: boolean;
    HasAttachment?: boolean;
    HasAutonomy?: boolean;
    HasCompliance?: boolean;
    HasInteraction?: boolean;
    HasSelfRegulation?: boolean;
    HasSocialCommunication?: boolean;
    ReferralNotes: string;
    ReferralAgency: string;
    OtherReferralSource: string;
    //has own look up
    StatusId: number;

    constructor() {
        this.DOB = null;
        this.AgeMonth = null;
        this.VAUserId = null;
        this.RegionId = null;
        this.City = null;
        this.ZipCode = null;
        this.HomeLanguage = null;
        this.ProgramId = null;
        this.ClassroomId = null;
        this.ClassStudentCount = null;
        this.NeedsInterpreter = null;
        this.NeedsFosterCare = null;
        this.Race = null;
        this.IsHispanic = null;
        this.Gender = null;
        this.IsIFSP = null;
        this.IFSPSvc = null;
        this.Diagnosis = null;
        this.Medications = null;
        this.Allergies = null;
        this.Referral = null;
        this.OtherAgencies = null;
        this.HasExpulsionRisk = null;
        this.ReceivesSubsidy = null;
        this.StartedAttending = new Date().toLocaleDateString();
        this.HasAdaptiveBehavior = null;
        this.HasAffect = null;
        this.HasAggression = null;
        this.HasAttachment = null;
        this.HasAutonomy = null;
        this.HasCompliance = null;
        this.HasInteraction = null;
        this.HasSelfRegulation = null;
        this.HasSocialCommunication = null;
        this.ReferralNotes = null;
        this.ReferralAgency = null;
        this.OtherReferralSource = null;
        this.StatusId = null;
    }   
}